<template>
  <a
    class="frisbuy-outfit-product-item"
    @click="($event) => openLink($event, product.link)"
  >
    <div class="frisbuy-outfit-product-item__image">
      <div v-if="product.isSimilar" class="frisbuy-outfit-product-item__similar-product">
        ПОХОЖИЙ ТОВАР
      </div>
      <img
        :src="getDomainSubstitute(product.sku?.picUrl)"
        @error="errorImageHandler"
      />
    </div>

    <div class="frisbuy-outfit-product-item__info">
      <div class="frisbuy-outfit-product-item__text">
        <div class="frisbuy-outfit-product-item__title">
          <span>
            {{ product.title }}
          </span>
        </div>

        <FavoriteButton
          @click.stop="() => likeButtonClick()"
          :isLiked="isLiked"
          :productArticle="product.sku?.vendorCode"
        />
      </div>

      <div v-if="product.sku?.price" class="frisbuy-outfit-product-item__price">
        <span class="frisbuy-outfit-product-item__price--actual">
          {{ product.sku.price.replaceAll(" ", "") }}<span class="frisbuy-outfit-product-item__currency-symbol">₽</span>
        </span>
        <div
          v-if="product.sku?.priceOld"
          class="span frisbuy-outfit-product-item__price--old"
        >
          {{ product.sku.priceOld.replaceAll(" ", "") }}<span class="frisbuy-outfit-product-item__currency-symbol">₽</span>
        </div>
        <div
          v-if="product.sku?.priceOld"
          class="span frisbuy-outfit-product-item__price--discount"
        >
         {{ Math.round(+product.sku?.price.replaceAll(" ", "") / +product.sku?.priceOld.replaceAll(" ", "") * 100 - 100) }}
         <span class="frisbuy-outfit-product-item__discount-symbol">%</span>
        </div>
      </div>

      <button class="frisbuy-outfit-product-item__buy-button" v-show="false">
        <svg
          width="14"
          height="18"
          viewBox="0 0 14 18"
          version="1.1"
          style="fill: none"
        >
          <path
            d="m 0.5,5.5 h 13 V 16 c 0,0.3978 -0.158,0.7794 -0.4393,1.0607 C 12.7794,17.342 12.3978,17.5 12,17.5 H 2 C 1.60218,17.5 1.22064,17.342 0.93934,17.0607 0.658035,16.7794 0.5,16.3978 0.5,16 Z"
            id="path2"
            style="stroke: #6e6e6e"
          />
          <path
            d="m 0.5,5.5 h 13 V 16 c 0,0.3978 -0.158,0.7794 -0.4393,1.0607 C 12.7794,17.342 12.3978,17.5 12,17.5 H 2 C 1.60218,17.5 1.22064,17.342 0.93934,17.0607 0.658035,16.7794 0.5,16.3978 0.5,16 Z"
            id="path4"
            style="stroke: #6e6e6e"
          />
          <path
            d="M 10,7.5 V 3.533 C 10.0043,2.73301 9.69065,1.96408 9.12806,1.39531 8.56548,0.82654 7.80003,0.5045 7.00004,0.5 6.20005,0.5045 5.4346,0.82654 4.87202,1.39531 4.30944,1.96408 3.99579,2.73301 4.00004,3.533 V 7.5"
            id="path6"
            style="
              stroke: #6e6e6e;
              stroke-linecap: round;
              stroke-linejoin: round;
            "
          />
        </svg>
      </button>
    </div>
  </a>
</template>

<style scoped lang="scss">
@import "@/gallery/mixins.scss";

* {
  box-sizing: border-box;
}

a,
a:hover,
a:visited,
a:active {
  color: #525252;
  text-decoration: none;
}

.frisbuy-outfit-product-item {
  display: flex;
  flex-direction: column;

  // width: 213px;
  // height: 315px;
  // aspect-ratio: 213 / 302;
  // min-width: fit-content;
  font-family: inherit;

  .frisbuy-outfit-product-item__image {
    display: flex;
    position: relative;
    width: 100%;
    // aspect-ratio: 212 / 257;
    width: 123px;
    height: 181px;

    background-color: #e6e6e6;

    img {
      position: absolute;
      inset: 0;

      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .frisbuy-like-button {
      position: absolute;
      inset: 10px 10px auto auto;

      width: 21px;

      margin: 0;
    }
  }

  .frisbuy-outfit-product-item__info {
    display: flex;
    flex-direction: column;
    position: relative;
    flex-grow: 1;
    gap: 4px;

    font-size: 14px;

    margin-top: 4px;

    .frisbuy-outfit-product-item__text {
      display: flex;
      gap: 4px;
      width: 100%;
      overflow: hidden;

      .frisbuy-outfit-product-item__title {
        color: rgba(0, 11, 11, 1);
        text-transform: uppercase;
        font-size: 11px;
        line-height: 13px;

        height: 26px;

        span {
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
      }
    }

    .frisbuy-outfit-product-item__price {
      display: flex;
      flex-direction: row;
      gap: 4px;
      width: fit-content;
      height: 25%;

      font-size: 11px;
      line-height: 13px;
      white-space: nowrap;

      color: rgba(48, 54, 53, 1);

      &--old {
        text-decoration: line-through;
      }

      &--discount {
        color: rgba(250, 74, 25, 1);
      }
    }

    .frisbuy-outfit-product-item__buy-button {
      display: block;
      position: relative;
      top: 0;
      right: 0;

      flex: 0 0 auto;

      width: 36px;
      height: 36px;
      aspect-ratio: 1 / 1;
      border: solid #00000060 1px;
      background-color: transparent;

      cursor: pointer;

      margin: auto 0 auto 8px;
      padding: 0;

      svg {
        display: block;
        width: 14px;

        margin: auto;
      }
    }
  }
}

.frisbuy-outfit-product-item__similar-product {
  position: absolute;
  text-transform: uppercase;
  z-index: 2;
  left: 4px;
  bottom: 4px;
  font-size: 10px;
  line-height: 12px;
  font-weight: 600;
  padding: 0 2px;
  background-color: rgba(255, 255, 255, 0.8);
}

// media queries
.frisbuy-outfit-product-item {
  // container-type: inline-size;

  @container (max-width: 172px) {
    .frisbuy-outfit-product-item__info {
      .frisbuy-outfit-product-item__text {
        .frisbuy-outfit-product-item__price {
          font-size: 0.8em;

          &--old {
            @container (max-width: 172px) {
              margin-left: 4px;
            }
          }
        }
      }

      .frisbuy-outfit-product-item__buy-button {
        width: 24px;
        height: 24px;

        svg {
          width: 10px;
        }
      }
    }
  }
}
</style>

<script lang="ts">
// Modules
import { PropType, defineComponent } from "vue";
// Components
// import LikeButton from "./LikeButton.vue";
import FavoriteButton from "./FavoriteButton.vue";
// Services
import { MediaCatcher } from "@/common/services/ErrorHandler/ErrorCatcher";
import { DomainSubstitute } from "@/common/services/DomainSubstitute/DomainSubstitute";
// Consts
import widgetTypes from "@/common/consts/widgetTypes";
// Types
import { IPostLinkInList } from "@/gallery/interfaces";

export default defineComponent({
  components: { 
    // LikeButton, 
    FavoriteButton
  },

  emits: {
    clickProduct(product: IPostLinkInList) {
      return product;
    },

    like: null,
  },

  props: {
    product: {
      type: Object as PropType<IPostLinkInList>,
      required: true,
    },

    linkTarget: {
      type: String as PropType<"_self" | "_blank" | "_parent" | "_top">,
      required: false,
      default: "_self",
    },

    isLiked: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {};
  },

  methods: {
    openLink($event: MouseEvent, link: string) {
      window.open(link, this.linkTarget);

      this.$emit("clickProduct", this.product);
    },

    getDomainSubstitute(srcUrl: string): string {
      return DomainSubstitute(srcUrl);
    },

    errorImageHandler(e: Event) {
      MediaCatcher(e, 2, widgetTypes.OUTFIT_ON_MODEL);
    },

    likeButtonClick() {
      this.$emit("like");
    },
  },
});
</script>
